import type { ToolCallGenericMessage } from '@terra/shared-dto-chat-types';

const HIDDEN_LIVE_TOOL_NAMES = new Set([
  'bind-working-target',
  'list-tenant-targets',
]);

const UNEXPECTED_ERROR_LABEL_PATTERN =
  /^(StreamError|UnexpectedError)(?:\s*\(Chat ID:.*\))?$/i;

function isHiddenLiveToolName(toolName: string | undefined): boolean {
  if (!toolName) return false;

  return HIDDEN_LIVE_TOOL_NAMES.has(toolName.toLowerCase());
}

function isUnexpectedErrorUserLabel(value: string | undefined): boolean {
  if (!value) return false;

  return UNEXPECTED_ERROR_LABEL_PATTERN.test(value.trim());
}

function shouldHideUnexpectedErrorCard({
  toolName,
  message,
  labelPast,
  labelPresent,
}: {
  toolName: string | undefined;
  message: string | undefined;
  labelPast: string | undefined;
  labelPresent: string | undefined;
}): boolean {
  return (
    isUnexpectedErrorUserLabel(toolName) ||
    isUnexpectedErrorUserLabel(labelPast) ||
    isUnexpectedErrorUserLabel(labelPresent) ||
    isUnexpectedErrorUserLabel(message)
  );
}

export function shouldHideLiveToolCall({
  toolCallId,
  toolName,
  metadata,
  message,
  labelPast,
  labelPresent,
}: {
  toolCallId: string | undefined;
  toolName: string | undefined;
  metadata: ToolCallGenericMessage['metadata'];
  message?: string;
  labelPast?: string;
  labelPresent?: string;
}): boolean {
  if (
    shouldHideUnexpectedErrorCard({
      toolName,
      message,
      labelPast,
      labelPresent,
    })
  ) {
    return true;
  }

  const parentToolCallId = metadata?.parentToolCallId;
  const isNestedToolCall =
    typeof parentToolCallId === 'string' ||
    toolCallId?.includes(':child:') === true;

  if (isNestedToolCall) {
    return false;
  }

  return isHiddenLiveToolName(toolName);
}
